import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BASE_URL } from '@ai-platform/utils';

import { StoreProvider } from './store';
import { AppRoutes } from './pages';
import { ScrollRestoration } from './components/ScrollRestoration';
import { UserProvider, ModalProvider } from './contexts';
import { AppMeta } from './App.meta';

import './styles/global.scss';

export const App: React.FC = () => {
    return (
        <HelmetProvider>
            <AppMeta />
            <BrowserRouter basename={BASE_URL}>
                <StoreProvider>
                    <UserProvider>
                        <ModalProvider>
                            <ScrollRestoration>
                                <AppRoutes />
                            </ScrollRestoration>
                        </ModalProvider>
                    </UserProvider>
                </StoreProvider>
            </BrowserRouter>
        </HelmetProvider>
    );
};
